(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ConstantContact",
                    {
                        url: "/ConstantContact",
                        component: "constantContact",
                        redirectTo: "Home.Tools.MarketingTrackerNew.DigitalMarketing.ConstantContact.CCCampaignList"
                    });
        }
    ]);

    app.component("constantContact",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ConstantContact/constant-contact-template.html",
            controller: constantContactController,
            bindings: {
            }
        });

    constantContactController.$inject = [];
    function constantContactController() {
        var $ctrl = this;        
    }

})(window.app, window.angular); //jshint ignore:line